import * as React from "react";

function CrownHoldingsIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 92 31"
    >
      <defs>
        <clipPath>
          <rect width="92" height="31" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-crown-holdings)">
        <path
          data-name="Path 7058"
          d="M11.677-5.79l3.083.978A6.915,6.915,0,0,1,12.4-.983,6.726,6.726,0,0,1,8.218.269,6.774,6.774,0,0,1,3.062-1.875a8.2,8.2,0,0,1-2.02-5.86,8.609,8.609,0,0,1,2.03-6.107,6.962,6.962,0,0,1,5.339-2.175,6.55,6.55,0,0,1,4.694,1.708,6.212,6.212,0,0,1,1.611,2.9l-3.147.752A3.338,3.338,0,0,0,10.4-12.59,3.339,3.339,0,0,0,8.25-13.3a3.583,3.583,0,0,0-2.841,1.257,6.161,6.161,0,0,0-1.09,4.071A6.606,6.606,0,0,0,5.393-3.717,3.488,3.488,0,0,0,8.186-2.449a3.185,3.185,0,0,0,2.181-.806A4.68,4.68,0,0,0,11.677-5.79ZM17.5,0V-15.748h6.692a11.455,11.455,0,0,1,3.668.424,3.619,3.619,0,0,1,1.832,1.509,4.537,4.537,0,0,1,.688,2.481,4.2,4.2,0,0,1-1.042,2.927A5,5,0,0,1,26.222-6.95a7.418,7.418,0,0,1,1.7,1.321,17.948,17.948,0,0,1,1.81,2.557L31.657,0h-3.8l-2.3-3.427A22.228,22.228,0,0,0,23.88-5.742a2.44,2.44,0,0,0-.956-.655,5.241,5.241,0,0,0-1.6-.177h-.645V0Zm3.18-9.088h2.353a12.148,12.148,0,0,0,2.857-.193,1.713,1.713,0,0,0,.892-.666,2.05,2.05,0,0,0,.322-1.182,1.888,1.888,0,0,0-.424-1.284,1.947,1.947,0,0,0-1.2-.618q-.387-.054-2.32-.054H20.679ZM32.731-7.777a10.016,10.016,0,0,1,.72-4.039,7.412,7.412,0,0,1,1.466-2.159,6.131,6.131,0,0,1,2.036-1.418,8.646,8.646,0,0,1,3.395-.623,7.394,7.394,0,0,1,5.57,2.159,8.275,8.275,0,0,1,2.089,6,8.248,8.248,0,0,1-2.073,5.967A7.337,7.337,0,0,1,40.391.269,7.412,7.412,0,0,1,34.8-1.875,8.133,8.133,0,0,1,32.731-7.777Zm3.276-.107A5.9,5.9,0,0,0,37.243-3.83a4.025,4.025,0,0,0,3.137,1.38A3.99,3.99,0,0,0,43.5-3.819,6.018,6.018,0,0,0,44.72-7.928a5.922,5.922,0,0,0-1.187-4.039A4.016,4.016,0,0,0,40.38-13.3a4.043,4.043,0,0,0-3.169,1.348A5.95,5.95,0,0,0,36.008-7.885ZM52.723,0l-3.76-15.748h3.255L54.592-4.931l2.879-10.817h3.781l2.761,11,2.417-11h3.2L65.807,0H62.434L59.3-11.773,56.171,0ZM71.285,0V-15.748h3.094L80.824-5.231V-15.748h2.954V0h-3.19L74.239-10.27V0Z"
          transform="translate(3 23)"
          fill="#106f2d"
        />
      </g>
    </svg>
  );
}

export default CrownHoldingsIcon;
